import {AbstractModel} from './abstract-model';

export class SiteConfigParam extends AbstractModel {
  key: string | null = null;
  name: string | null = null;
}
